module.exports = Promise.all([parcelRequire.load("g1w0i"), parcelRequire.load("btW7r"), parcelRequire.load("auDuq")]).then(() => parcelRequire('3U5pN'));